import { Swiper } from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'
import 'swiper/css';

function initLazySwiperTournament($){
    let need_init = false;
    if(window.innerWidth < 991){
        need_init = true;
    }
    if(need_init){
        $('.lazy-swiper:not(.swiper-initialized)').each(function(){
            $(this).toggleClass('swiper', need_init);
            $(this).find('.lazy-swiper__wrapper').toggleClass('swiper-wrapper', need_init);
            $(this).find('.lazy-swiper__wrapper').toggleClass('row', !need_init);
            $(this).find('.lazy-swiper__slide').toggleClass('swiper-slide', need_init);

            const btn_prev = $(this).find('.grid-tournament-navigation__button.-prev')[0];
            const btn_next = $(this).find('.grid-tournament-navigation__button.-next')[0];
            const pagination = $(this).find('.grid-tournament-navigation__pagination')[0];

            console.log(btn_prev, btn_next, pagination)

            const labels = {}
            
            $(this).find('.grid-tournament__heading').each(function(i) {
                labels[i+1] = $(this).html().trim()
            })

            const swiper = new Swiper(this, {
                slidesPerView: 1.08,
                spaceBetween: 0,
                pagination: {
                    el: pagination,
                    type: "custom",
                    renderCustom: function (swiper, current, total) {
                        return labels[current]
                    }
                },
                navigation: {
                    nextEl: btn_next,
                    prevEl: btn_prev,
                },
                modules: [Navigation, Pagination],
            });
            this.__related_swiper = swiper;

        });
    }else{
        $('.lazy-swiper.swiper-initialized').each(function(){
            if(this.__related_swiper){
                this.__related_swiper.destroy(true, true);

                $(this).removeClass('swiper-backface-hidden')
                $(this).removeClass('swiper')
                $(this).find('.lazy-swiper__wrapper').removeClass('swiper-wrapper');
                $(this).find('.lazy-swiper__wrapper').addClass('row');
                $(this).find('.lazy-swiper__slide').removeClass('swiper-slide');
            }
        })
    }
}

export {
    initLazySwiperTournament,
}